var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sunset",
    clipPath: "url(#clip0_1981_1967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7133 12.8186H0.286747C0.128418 12.8186 0 12.6905 0 12.5319C0 12.3738 0.128418 12.2451 0.286747 12.2451H19.7133C19.8719 12.2451 20 12.3738 20 12.5319C20 12.6905 19.8719 12.8186 19.7133 12.8186Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.1516 15.0852H3.84828C3.68994 15.0852 3.56152 14.9568 3.56152 14.7985C3.56152 14.6401 3.68994 14.5117 3.84828 14.5117H16.1516C16.3102 14.5117 16.4386 14.6401 16.4386 14.7985C16.4386 14.9568 16.3102 15.0852 16.1516 15.0852Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.2667 17.0278H8.0575C7.89917 17.0278 7.77075 16.8994 7.77075 16.7411C7.77075 16.5828 7.89917 16.4543 8.0575 16.4543H12.2667C12.425 16.4543 12.5534 16.5828 12.5534 16.7411C12.5534 16.8994 12.425 17.0278 12.2667 17.0278Z",
    fill: "#37474F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.59473 11.0977C3.59473 7.54346 6.47545 4.6626 10.0296 4.6626C13.5834 4.6626 16.4644 7.54346 16.4644 11.0977",
    fill: "#FFCE31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.4646 11.3844C16.3059 11.3844 16.1778 11.2557 16.1778 11.0976C16.1778 7.70732 13.4199 4.94922 10.0297 4.94922C6.63955 4.94922 3.88159 7.70732 3.88159 11.0976C3.88159 11.2557 3.75317 11.3844 3.59484 11.3844C3.43652 11.3844 3.30811 11.2557 3.30811 11.0976C3.30811 7.39109 6.32345 4.37573 10.0297 4.37573C13.736 4.37573 16.7513 7.39109 16.7513 11.0976C16.7513 11.2557 16.6229 11.3844 16.4646 11.3844Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.22934 11.1997H0.286747C0.128418 11.1997 0 11.0716 0 10.913C0 10.7549 0.128418 10.6262 0.286747 10.6262H2.22934C2.38796 10.6262 2.51637 10.7549 2.51637 10.913C2.51637 11.0716 2.38796 11.1997 2.22934 11.1997Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.03247 2.91772L4.87628 4.76182L3.03247 2.91772Z",
    fill: "#FFCA72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M4.87638 5.04852C4.803 5.04852 4.7299 5.02058 4.67374 4.96456L2.82964 3.12046C2.7176 3.00842 2.7176 2.82694 2.82964 2.7149C2.94169 2.60285 3.12317 2.60285 3.23521 2.7149L5.07931 4.55899C5.19135 4.67104 5.19135 4.85251 5.07931 4.96456C5.02314 5.02058 4.94977 5.04852 4.87638 5.04852Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M19.7132 11.1997H18.0944C17.9357 11.1997 17.8076 11.0716 17.8076 10.913C17.8076 10.7549 17.9357 10.6262 18.0944 10.6262H19.7132C19.8718 10.6262 20 10.7549 20 10.913C20 11.0716 19.8718 11.1997 19.7132 11.1997Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.0265 2.91772L15.1824 4.76182L17.0265 2.91772Z",
    fill: "#FFCA72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.1824 5.04852C15.109 5.04852 15.0357 5.02058 14.9798 4.96456C14.8677 4.85251 14.8677 4.67104 14.9798 4.55899L16.8239 2.7149C16.9359 2.60285 17.1174 2.60285 17.2294 2.7149C17.3415 2.82694 17.3415 3.00842 17.2294 3.12046L15.3853 4.96456C15.3292 5.02058 15.2558 5.04852 15.1824 5.04852Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M9.99988 3.10543C9.84155 3.10543 9.71313 2.97716 9.71313 2.81868V0.552364C9.71313 0.394035 9.84155 0.265625 9.99988 0.265625C10.1582 0.265625 10.2866 0.394035 10.2866 0.552364V2.81868C10.2866 2.97716 10.1582 3.10543 9.99988 3.10543Z",
    fill: "#37474F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1981_1967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.7622,
    fill: "white",
    transform: "translate(0 0.265625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunset);
export default __webpack_public_path__ + "static/media/sunset.0e1be28148520f726fa5989bc9489ff0.svg";
export { ForwardRef as ReactComponent };